import { Link } from "react-router-dom"
import { TrialFormDialog } from '../components/common/Trial/TrialFormDialog'
import { useState, useEffect } from 'react'
import { useRouteListener } from "@/hooks/useRouteListener"

export default function Header({ routes = [
    { path: "/mainland-china", label: "Mainland China" },
    { path: "/hongkong-sar", label: "HongKong SAR" },
    { path: "/united-states", label: "United States" },
    { path: "/support", label: "Support" },
    { path: "/about", label: "About iData" },
  ], scrollThreshold }) {
  const [ trialStatus, setTrialStatus ] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    if (scrollThreshold) {
      setIsScrolled(window.scrollY > scrollThreshold)
      const handleScroll = () => {
        // Use the scrollThreshold prop to determine when to change style
        setIsScrolled(window.scrollY > scrollThreshold)
      }

      window.addEventListener("scroll", handleScroll)

      // Cleanup function to remove the event listener
      return () => {
        window.removeEventListener("scroll", handleScroll)
      }
    }
  }, [scrollThreshold])

  const { currentPath } = useRouteListener()

   // 检查是否为当前路由
  const isActiveRoute = (path) => {
    return currentPath === path || currentPath.startsWith(path + "/")
  }

  return (
    <header className={`bg-gray-900 text-white h-[60px] backdrop-blur
    fixed top-0 z-[999] w-[100%] border-b border-[#8D9EB9] ${isScrolled ? 'bg-white' : 'bg-[#181818]'}`}>
      <div className="container container-max-w mx-auto px-4 h-full">
        <div className="flex items-center justify-between h-16 h-full">
          <div className="flex items-center space-x-8 h-full">
            <Link to="/" className="flex items-center space-x-2">
              <div className={`w-[105px] h-[34px] bg-contain bg-[url(../assets/images/idata-logo.gif)]` }></div>
            </Link>
            <div className="w-[1px] h-[22px] bg-[#bfbfbf]"></div>
            <nav className="hidden md:flex space-x-2 h-full">
              {
                routes.map(route => {
                  return ( 
                    <Link to={route.path} className={`relative  transition-colors px-[10px]
                    text-[16px] h-full flex items-center ${isScrolled ? 'hover:bg-[#F3F3F3] text-[#333] hover:text-[#161616]' : 'hover:text-[#fff] text-[#bfbfbf] '}
                    ${isActiveRoute(route.path) ? (isScrolled ? 'text-[#161616]' : 'text-[#fff]') : ''}`}>
                      { route.label }
                      { isActiveRoute(route.path) && <div className="w-full h-[3px] px-[10px] bg-[#0066FF] absolute bottom-[-1px] left-[0]"></div> }
                    </Link>
                  )
                })
              }
            </nav>
          </div>
          <div className={`hover:bg-[#0066FF] hover:border-[#0066FF] w-[105px] h-[28px] text-[16px] border
          border-[#BFBFBF] text-center cursor-pointer font-[500] ${isScrolled && 'border-[#4D4D4D] text-[#161616] hover:text-[#fff]'}`}
          onClick={ () => setTrialStatus(true) }>
            Free Trial
          </div>
        </div>
      </div>
      <TrialFormDialog open={ trialStatus } onOpenChange={ setTrialStatus }></TrialFormDialog>
    </header>
  )
}
